import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import LoginForm from './LoginForm';
import ForgotForm from './ForgotForm';
import OtpForm from '../../OtpForm';
import ConfigsContext from '../../../../contextProviders/ConfigsContext';

const DISPLAY_FORM = {
  LOGIN: 'login',
  FORGOT: 'forgot',
  OTP: 'otp',
};

const isMethodEnabled = (methods, type) =>
  Array.isArray(methods) &&
  methods.some(m => m && m.type === type && m.enabled === true);

export default function LoginForgotForms({
  redirectLink,
  logo,
  onLoggedIn,
  ignoreRedirection,
}) {
  const containerId = 'm_login';
  const { tenant } = useContext(ConfigsContext);
  const authMethods = (tenant && tenant.authMethods) || [];
  const otpEnabled = isMethodEnabled(authMethods, 'otpEmail');
  const passwordEnabled =
    authMethods.length === 0 || isMethodEnabled(authMethods, 'password');
  const [formDisplayed, setFormDisplayed] = useState(
    otpEnabled && !passwordEnabled ? DISPLAY_FORM.OTP : DISPLAY_FORM.LOGIN,
  );

  useEffect(() => {
    const container = (() => {
      switch (formDisplayed) {
        case DISPLAY_FORM.FORGOT:
          return '.m-login__forget-password';
        case DISPLAY_FORM.LOGIN:
        default:
          return '.m-login__signin';
      }
    })();

    $(`#${containerId}`).find(container).animateClass('flipInX animated');
  }, [formDisplayed]);

  const displayLoginForm = () => setFormDisplayed(DISPLAY_FORM.LOGIN);
  const displayForgotPasswordForm = () => setFormDisplayed(DISPLAY_FORM.FORGOT);
  const displayOtpForm = () => setFormDisplayed(DISPLAY_FORM.OTP);

  const containerClasses = cx(
    'm-login-container',
    'm-login__logo',
    {
      'm-login--signin':
        formDisplayed === DISPLAY_FORM.LOGIN ||
        formDisplayed === DISPLAY_FORM.OTP,
    },
    { 'm-login--forget-password': formDisplayed === DISPLAY_FORM.FORGOT },
  );

  return (
    <div className={containerClasses} id={containerId}>
      {logo && <img src={logo} alt="logo" className="login-logo" />}
      {formDisplayed !== DISPLAY_FORM.OTP && (
        <>
          <LoginForm
            redirectLink={redirectLink}
            displayForgotPassword={displayForgotPasswordForm}
            displayOtpForm={otpEnabled ? displayOtpForm : null}
            onLoggedIn={onLoggedIn}
            ignoreRedirection={ignoreRedirection}
          />
          <ForgotForm displayLoginForm={displayLoginForm} />
        </>
      )}
      {formDisplayed === DISPLAY_FORM.OTP && (
        <OtpForm
          onBackToPassword={passwordEnabled ? displayLoginForm : null}
          showBackToPassword={passwordEnabled}
          redirectPath={redirectLink}
          dropdownParent="#modalBody"
          variant="modal"
        />
      )}
    </div>
  );
}

LoginForgotForms.propTypes = {
  redirectLink: PropTypes.string.isRequired,
  logo: PropTypes.string.isRequired,
  onLoggedIn: PropTypes.func,
  ignoreRedirection: PropTypes.bool,
};

LoginForgotForms.defaultProps = {
  onLoggedIn: null,
  ignoreRedirection: null,
};
